import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import EcoIcon from '@material-ui/icons/Eco';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
	root: {
		textAlign: 'center',
		padding: theme.spacing(8, 2),
		backgroundColor: theme.palette.grey[50],
		borderRadius: theme.spacing(2),
		border: `2px dashed ${theme.palette.grey[300]}`,
	},
	icon: {
		fontSize: 64,
		color: theme.palette.grey[400],
		marginBottom: theme.spacing(2),
	},
	title: {
		fontWeight: 600,
		marginBottom: theme.spacing(1),
	},
	description: {
		color: theme.palette.text.secondary,
		marginBottom: theme.spacing(3),
		maxWidth: 400,
		margin: '0 auto',
		marginBottom: theme.spacing(3),
	},
}));

const EmptyState = ({ onAddClick }) => {
	const classes = useStyles();
	const { t } = useTranslation();

	return (
		<Box className={classes.root}>
			<EcoIcon className={classes.icon} />
			<Typography variant="h6" className={classes.title}>
				{t('No crops registered yet')}
			</Typography>
			<Typography variant="body2" className={classes.description}>
				{t('Start tracking your crop rotation by adding your first crop')}
			</Typography>
			<Button
				variant="contained"
				color="primary"
				startIcon={<AddIcon />}
				onClick={onAddClick}
			>
				{t('Add First Crop')}
			</Button>
		</Box>
	);
};

export default EmptyState;
